import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { setActiveCommunity } from '../../../actions/userActions'
import CommunityAvatarPlaceholder from '../../../assets/images/mock/classRowBanner.png'

import classes from './CommunitySwitcher.module.scss'

const CommunitySwitcher = ({ user }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const currentUser = useSelector((state) => state.user.current_user)
  const activeCommunityId = useSelector((state) => state.user.active_community_id)

  const [expanded, setExpanded] = useState(false)

  const communities = currentUser?.communities || []
  const isOwnProfile = currentUser?.id === user.id
  const isFamilyAdminOnFamilyMember = currentUser?.family_admin && currentUser?.family_id === user.family_id

  if (communities.length < 2 || !(isOwnProfile || isFamilyAdminOnFamilyMember)) {
    return null
  }

  const activeCommunity = communities.find((community) => community.id === activeCommunityId) || communities[0]

  const toggleExpanded = () => setExpanded(!expanded)

  const chooseCommunity = (community) => {
    if (community.id !== activeCommunity.id) {
      dispatch(setActiveCommunity(community.id))
    }
  }

  return (
    <div className={classNames(classes.switcher, 'hidden-sm-down mr-3')}>
      <Dropdown isOpen={expanded} toggle={toggleExpanded}>
        <DropdownToggle tag='button' type='button' className={classNames(classes.toggle, 'd-flex align-items-center justify-content-between')}>
          <span className={classes.toggleName}>{activeCommunity.name}</span>
          <i className='fa fa-angle-down ml-3' aria-hidden='true' />
        </DropdownToggle>

        <DropdownMenu right positionFixed className={classes.menu}>
          {communities.map((community) => (
            <DropdownItem
              key={community.id}
              className={classNames(classes.item, 'd-flex align-items-center')}
              onClick={() => chooseCommunity(community)}
            >
              <div className={classNames(classes.itemLogo, 'smaller-round-image-wrapper bg-white')}>
                <img className='round-image' src={community.photo ? community.photo.file_url : CommunityAvatarPlaceholder} alt={community.name} />
              </div>

              <div className='ml-3 text-left'>
                <div className={classes.itemName}>{community.name}</div>
                <div className={classes.itemSubtitle}>
                  {t('common.activeEnrollments', { count: community.active_enrollments_count || 0 })}
                </div>
              </div>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </div>
  )
}

CommunitySwitcher.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
    family_id: PropTypes.number,
  }).isRequired,
}

export default CommunitySwitcher
